module.exports = __webpack_public_path__ + "static/media/Gotham-MediumItalic.316c3977.eot";


//////////////////
// WEBPACK FOOTER
// ./src/theme/fonts/Gotham-MediumItalic.eot
// module id = 876
// module chunks = 40